import {SsaiAdBreakMetadata, SsaiAdMetadata, SsaiAdQuartile, SsaiAdQuartileMetadata} from '../../api/AdapterAPI';

export type InternalSsaiMetadata = SsaiAdBreakMetadata & SsaiAdMetadata;

type SsaiEngagementBaseData = {
  adIndex: number;
  currentAdImpressionId: string;
  currentAdMetadata: InternalSsaiMetadata;
  type: 'error' | 'quartile' | 'started';
};

export type SsaiEngagementErrorData = SsaiEngagementBaseData & {
  errorCode: number;
  errorMessage: string;
  timeSinceAdStartedInMs: number | undefined;
  type: 'error';
};

export function isSsaiEngagementErrorData(data: SsaiEngagementInteractionData): data is SsaiEngagementErrorData {
  return data.type === 'error';
}

export type SsaiEngagementQuartileData = SsaiEngagementBaseData & {
  quartile: SsaiAdQuartile;
  quartileMetadata: SsaiAdQuartileMetadata;
  timeSinceAdStartedInMs: number | undefined;
  type: 'quartile';
};

export function isSsaiEngagementQuartileData(data: SsaiEngagementInteractionData): data is SsaiEngagementQuartileData {
  return data.type === 'quartile';
}

export type SsaiEngagementStartedData = SsaiEngagementBaseData & {type: 'started'};

export function isSsaiEngagementStartedData(data: SsaiEngagementInteractionData): data is SsaiEngagementStartedData {
  return data.type === 'started';
}

export type SsaiEngagementInteractionData =
  | SsaiEngagementErrorData
  | SsaiEngagementQuartileData
  | SsaiEngagementStartedData;
